import { CalendarIcon } from "@src/assets/general-icons/CalendarIcon";
import React, { CSSProperties } from "react";
import DatePicker from "react-datepicker";
import { Control, FieldValues, Path, useController } from "react-hook-form";
import { clx } from "../utils/stringUtils";
import styles from "./DateInput.module.scss";
import "./TimeInputStyle.css";
import inputStyles from "./Input.module.scss";

interface ITimeInput<T extends FieldValues> {
	control: Control<T>;
	name: Path<T>;
	controlSize?: "n" | "sm";
	wrapperStyle?: CSSProperties;
	label?: string;
	placeholder?: string;
	intervalTime?: number;
	onFocus?: React.FocusEventHandler<HTMLInputElement>;
	disabled?: boolean;
}

export const TimeInput = <T extends FieldValues>({
	controlSize = "n",
	wrapperStyle,
	name,
	control,
	label,
	placeholder = "Default placeholder",
	intervalTime = 15,
	onFocus,
	disabled = false,
	...rest
}: ITimeInput<T>) => {
	const { field, fieldState } = useController({ name, control });

	const selectedDateTime = field.value ? new Date(field.value) : null;
	const { isDirty, invalid } = fieldState;

	const onDateChange = (data: Date | null) => {
		field.onChange(data);
	};

	const innerTernary = field.value && isDirty ? "success" : "none";
	const inputStatus = invalid ? "error" : innerTernary;

	return (
		<div className={styles.main}>
			{label && <div className={styles.label}>{label}</div>}
			<div className={clx({ [styles.root]: true, [inputStyles.small]: controlSize == "sm" })} style={wrapperStyle} {...rest}>
				<DatePicker
					className={clx({
						[styles.input]: true,
						[styles.inputError]: inputStatus === "error",
						[inputStyles.small]: controlSize == "sm",
						"time-picker": true,
					})}
					popperClassName="timepicker-popper"
					selected={selectedDateTime}
					showTimeSelect
					showTimeSelectOnly
					placeholderText={placeholder}
					onChange={onDateChange}
					onFocus={onFocus}
					dateFormat="h:mm aa"
					timeIntervals={intervalTime}
					disabled={disabled}
				/>
				<div className={styles.iconHolder}>
					<CalendarIcon />
				</div>
			</div>
		</div>
	);
};
